var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 84C31.25 84 16 68.75 16 50C16 31.25 31.25 16 50 16C68.75 16 84 31.25 84 50C84 68.75 68.75 84 50 84Z",
    fill: "#FFE27A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.67 49.03V43.05H54.89V63.02H58.75V69H42.67V63.02H46.61V49.03H42.67ZM46.31 35.61C46.31 34.36 46.75 33.29 47.64 32.4C48.52 31.51 49.59 31.06 50.84 31.06C52.11 31.06 53.18 31.51 54.06 32.4C54.94 33.29 55.37 34.36 55.37 35.61C55.37 36.86 54.93 37.92 54.04 38.8C53.16 39.68 52.09 40.12 50.84 40.12C49.61 40.12 48.54 39.67 47.65 38.78C46.76 37.9 46.31 36.84 46.31 35.61Z",
    fill: "#A67200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.bbbe679e9e5fb2c8d23b24b74b869613.svg";
export { ForwardRef as ReactComponent };